import { getPageKey } from "lib/navigation"
import { useRouter } from "next/router"
import { THEME } from "configs/theme"
import { EmptyResearchLayout } from "./emptyResearchLayout"
import { handleLogoutClick } from "../logoutButton"
import { useAccountPreferences } from "@common/context/accountPreferencesContext"
import SidenavIconsLayout from "@common/layouts/sidenavIconsLayout"
import Loader from "@common/loader"

import { getMenuConfig } from "lib/util"
import { useDashboardContext } from "context/dashboardContext"
import EmptyStateWrapper from "components/emptyStateWrapper"
import { getCustomerId } from "lib/filters"

export default function DashboardLayout({ children }) {
  const router = useRouter()
  const { isIconSidenavOpenPrefered, handlePinClick, isDarkMode } =
    useAccountPreferences()
  const { permissions, sourceList } = useDashboardContext()
  const selectedPageKey = getPageKey(router.asPath, router.query)
  const { menus } = THEME
  const customerId = getCustomerId()

  const menuConfig =
    customerId && getMenuConfig(router.asPath, menus.menuIcons, sourceList)

  return (
    <SidenavIconsLayout
      menuConfig={menuConfig}
      logoObj={THEME.logo}
      isIconSidenavExpandable={THEME.iconSidenavExpandable}
      isDarkMode={isDarkMode}
      selectedKey={selectedPageKey}
      handleLogoutClick={() => handleLogoutClick(router)}
      handlePinClick={handlePinClick}
      isExpanded={isIconSidenavOpenPrefered}
    >
      {renderMain()}
    </SidenavIconsLayout>
  )

  function renderMain() {
    const query = router?.query
    if (!permissions || !router || !query || Object.keys(query).length == 0) {
      return <Loader />
    }
    return <EmptyStateWrapper>{children}</EmptyStateWrapper>
  }
}

// context - read option 4 (bonus) here https://adamwathan.me/2019/10/17/persistent-layout-patterns-in-nextjs/
export const getLayout = (page) => (
  <EmptyResearchLayout>
    <DashboardLayout>{page}</DashboardLayout>
  </EmptyResearchLayout>
)

export const widgetContextLayout = (page) => {
  return <EmptyResearchLayout>{page}</EmptyResearchLayout>
}
